import {useEffect} from "react";

export interface UseKeyboardNavOptions {
    onPrev?: () => void;
    onNext?: () => void;
    onClose?: () => void;
    enabled?: boolean;
}

/**
 * Hook for keyboard navigation in image galleries
 * Handles Arrow keys for navigation and Escape for closing
 */
export function useKeyboardNav({onPrev, onNext, onClose, enabled = true}: UseKeyboardNavOptions): void {
    useEffect(() => {
        if (!enabled) {
            return;
        }

        const handleKeyDown = (e: KeyboardEvent): void => {
            switch (e.key) {
                case "ArrowLeft":
                    e.preventDefault();
                    onPrev?.();
                    break;
                case "ArrowRight":
                    e.preventDefault();
                    onNext?.();
                    break;
                case "Escape":
                    e.preventDefault();
                    onClose?.();
                    break;
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [enabled, onPrev, onNext, onClose]);
}
